<template>
  <button :class="classes" :aria-label="title"><IconLike /></button>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  title?: string
  active?: boolean
  size?: 'xs' | 'sm' | 'md'
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Add to favourites',
  size: 'sm',
  class: undefined,
})

const classes = computed(() => ({
  'app-button-like': true,
  'app-button-like--active': props.active,
  [`app-button-like--size-${props.size}`]: props.size,
  [`${props.class}`]: !!props.class,
}))
</script>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-button-like {
  height: auto;

  svg {
    fill: rgba($black, 0.3);
    stroke: $white;
    overflow: visible;
    @include transition('fill');
  }

  &:hover {
    svg {
      fill: $red;
    }
  }

  &.white {
    svg {
      stroke: $black;
      fill: rgba($black, 0);
    }

    &:hover {
      svg {
        fill: $red;
      }
    }
  }
}

.app-button-like--size-xs {
  width: 1.25rem;
}

.app-button-like--size-sm {
  width: 2rem;
}

.app-button-like--size-md {
  width: 2rem;

  @include media-breakpoint-up(md) {
    width: 2.5rem;
  }
}

.app-button-like--active {
  svg {
    fill: $red;
  }

  &:hover {
    svg {
      fill: rgba($black, 0.3);
    }
  }
}
</style>
